import { render, staticRenderFns } from "./com-list.vue?vue&type=template&id=66beaef3&scoped=true&"
import script from "./com-list.vue?vue&type=script&lang=js&"
export * from "./com-list.vue?vue&type=script&lang=js&"
import style0 from "./com-list.vue?vue&type=style&index=0&id=66beaef3&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66beaef3",
  null
  
)

export default component.exports